import React from 'react';
type SectionHeadingProps = {
  eyebrow?: string;
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  align?: 'left' | 'center';
  tone?: 'dark' | 'light';
  as?: 'h2' | 'h3';
};
export function SectionHeading({
  eyebrow,
  title,
  subtitle,
  align = 'center',
  tone = 'dark',
  as: Tag = 'h2'
}: SectionHeadingProps) {
  const alignment = align === 'center' ? 'text-center items-center' : 'text-left items-start';
  return <div className={`flex flex-col gap-3 ${alignment}`} data-id="element-253" data-mp="n099rmqox34f">
      {eyebrow ? <span className={`inline-flex rounded-full px-3 py-1 text-[11px] font-extrabold uppercase tracking-[0.18em] ${tone === 'light' ? 'bg-white/10 text-amber' : 'bg-flame-soft text-flame-dark'}`} data-id="element-254" data-mp="i7oiosz6544l">
          {eyebrow}
        </span> : null}
      <Tag className={`font-display text-[28px] font-black leading-[1.1] sm:text-[36px] ${tone === 'light' ? 'text-canvas' : 'text-night'}`} data-id="element-255" data-mp="8blivtrshhkt">
        {title}
      </Tag>
      {subtitle ? <p className={`max-w-2xl text-[15px] leading-relaxed sm:text-base ${tone === 'light' ? 'text-canvas/75' : 'text-muted'}`} data-id="element-256" data-mp="3vfsx654ojrbk">
          {subtitle}
        </p> : null}
    </div>;
}